import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";

const StarIcon = ({ coinId }) => {
  const [like, setLike] = useState(false);

  useEffect(() => {
    if (window.localStorage.coinList) {
      let favList = window.localStorage.coinList.split(",");
      if (favList.includes(coinId)) {
        setLike(true);
      } else {
        setLike(false);
      }
    }
  }, [coinId]);

  const idChecker = (e, id) => {
    e.stopPropagation();
    let favList = null;
    if (window.localStorage.coinList) {
      favList = window.localStorage.coinList.split(",").filter(Boolean);
    }

    if (favList && favList.length > 0) {
      if (favList.includes(id)) {
        const newList = favList.filter((coin) => coin !== id);
        window.localStorage.coinList = newList.join(",");
        setLike(false);
      } else {
        const newList = [...favList, id];
        window.localStorage.coinList = newList.join(",");
        setLike(true);
      }
    } else {
      window.localStorage.coinList = id;
      setLike(true);
    }
  };

  return (
    <button
      className={`star-btn ${like ? "active" : ""}`}
      onClick={(e) => idChecker(e, coinId)}
      title={like ? "Remove from watchlist" : "Add to watchlist"}
      aria-label="Favorite button"
    >
      <Star
        size={16}
        fill={like ? "#f59e0b" : "transparent"}
        color={like ? "#f59e0b" : "#64748b"}
      />
    </button>
  );
};

export default StarIcon;
